import React from 'react';

export function FilterHeader({ children, className = '' }) {
  return (
    <div className={`ci-modal-filters ${className}`.trim()}>{children}</div>
  );
}
